import { render, staticRenderFns } from "./product-offer-group-categories.vue?vue&type=template&id=da4f39b0&scoped=true"
import script from "./product-offer-group-categories.vue?vue&type=script&lang=js"
export * from "./product-offer-group-categories.vue?vue&type=script&lang=js"
import style0 from "./product-offer-group-categories.vue?vue&type=style&index=0&id=da4f39b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4f39b0",
  null
  
)

export default component.exports